import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from 'shared/hooks/useMediaQuery';
import { withTheme } from 'styled-components';
import DesktopCampaignBlock from './DesktopCampaignBlock';
import MobileCampaignBlock from './MobileCampaignBlock';

const CampaignContentBlock = ({
	theme = {},
	Heading = '',
	Text = '',
	Image = {},
	ContentLink = {},
	LayoutText = '',
	RightAlignedText = false,
}) => {
	const resolvedLayoutText =
		LayoutText || (RightAlignedText ? 'text-right' : 'text-left');

	const isLargeUp = useMediaQuery(
		`(min-width: ${theme.breakpoints.lg})`,
		true,
	);
	return (
		<>
			{isLargeUp ? (
				<DesktopCampaignBlock
					Heading={Heading}
					Text={Text}
					Image={Image}
					ContentLink={ContentLink}
					LayoutText={resolvedLayoutText}
				/>
			) : (
				<MobileCampaignBlock
					Heading={Heading}
					Text={Text}
					Image={Image}
					ContentLink={ContentLink}
				/>
			)}
		</>
	);
};

CampaignContentBlock.propTypes = {
	Heading: PropTypes.string,
	Text: PropTypes.string,
	Image: PropTypes.object,
	LayoutText: PropTypes.string,
	RightAlignedText: PropTypes.bool,
	ContentLink: PropTypes.object,
};

export default withTheme(CampaignContentBlock);
